import { Component, inject, ChangeDetectionStrategy } from '@angular/core';
import { BaseDialogComponent } from '../../../../kit/base-dialog/base-dialog.component';
import { fb } from '../../../../../modules/shared/shared.global-service';
import { DateInputComponent } from '../../../../kit/input/date-input/date-input.component';
import { TranslatePipe } from '@ngx-translate/core';
import { TextInputComponent } from '../../../../kit/input/text-input/text-input.component';
import { RadioInputComponent } from '../../../../kit/input/radio-input/radio-input.component';
import { ActionButtonsComponent } from '../../../../kit/action-buttons/action-buttons.component';
import { Validators } from '@angular/forms';
import { csszInsuranceAdministratorEnumOptions } from '@libs/types/src/services/enum/cssz-insurance-administrator.enum';
import { csszDateFormat } from '../utils-CSSZ';
import { contentGlobalSuccess } from '../../../../../modules/content/content.error';
import { SickNoteShortObject } from '@libs/types/src/services/object-type/cssz/sick-notes.object';
import { FolderSickNotesConfirmTakeoverModalStore } from './folder-sick-notes-confirm-takeover-modal.store';

@Component({
    selector: 'app-folder-sick-notes-confirm-takeover-modal',
    templateUrl: 'folder-sick-notes-confirm-takeover-modal.component.html',
    styleUrls: ['folder-sick-notes-confirm-takeover-modal.component.scss'],
    imports: [
        TranslatePipe,
        TextInputComponent,
        ActionButtonsComponent,
        RadioInputComponent,
        DateInputComponent,
    ],
    changeDetection: ChangeDetectionStrategy.Eager,
    providers: [FolderSickNotesConfirmTakeoverModalStore]
})
export class FolderSickNotesConfirmTakeoverModalComponent extends BaseDialogComponent {
    public readonly store = inject(FolderSickNotesConfirmTakeoverModalStore);

    protected form = fb.group({
        sszCode: fb.control<string | null>(null, [Validators.required]),
        insuranceAdministrator: fb.control<string | null>(null, [
            Validators.required,
        ]),
        dateFrom: fb.control<Date>(new Date(), [Validators.required]),
    });

    protected prefix = 'sickNotes.confirmTakeOver.form.';
    protected selectedItem: SickNoteShortObject | null = null;

    constructor() {
        super();
        this.selectedItem = this.dialogConfig.data.selectedItem;
    }

    protected confirm(): void | Promise<void> {
        if (this.form.isInvalid()) return;
        const folder = this.store.folder();
        if (folder && this.selectedItem) {
            this.store.api.takeOver({
                folderId: folder.id,
                sszCode: this.form.value.sszCode!,
                insuranceAdministrator: this.form.value.insuranceAdministrator!,
                serviceId: folder.serviceId,
                decisionNumber: this.selectedItem!.decisionNumber,
                name: folder.person.name,
                surname: folder.person.surname,
                insuranceNumber: this.selectedItem!.insuranceNumber,
                doctorName: this.store.currentUser()?.username || '',
                fromIcpe: this.selectedItem!.icpe,
                fromDoctroName: this.selectedItem!.doctorName,
                issueDate: csszDateFormat(new Date()) || '',
            }).then(() => {
                contentGlobalSuccess.next('common.created');
                this.dialogRef.close(true);
            });
        }
    }

    protected readonly csszInsuranceAdministratorEnumOptions = csszInsuranceAdministratorEnumOptions;
}
